declare namespace $ {

	export class $mol_view_tree2_to_js_test_ex_left_chaining_foo extends $mol_object {
		d( next?: number ): number
		c( next?: ReturnType< $mol_view_tree2_to_js_test_ex_left_chaining_foo['d'] > ): ReturnType< $mol_view_tree2_to_js_test_ex_left_chaining_foo['d'] >
		b( ): ReturnType< $mol_view_tree2_to_js_test_ex_left_chaining_foo['c'] >
		a( ): ReturnType< $mol_view_tree2_to_js_test_ex_left_chaining_foo['b'] >
	}
	
}

//# sourceMappingURL=left_chaining.view.tree.d.ts.map